import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  caricamentoInCorso: false,
  contratti: [],
  clienti: [],
  opzioniTabella: { data: [], columns: [] },
  mostraOrdiniFatture: false,
  ordini: [],
  fatture: [],
  currentContratto: false,
  caricamentoModale: false,
  tipoModale: 'MOVIMENTI',
  currentCliente: '',
};

const contrattiSlice = createSlice({
  name: 'contratti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaContratti(state, action) {
      state.contratti = action.payload;
    },
    aggiornaClienti(state, action) {
      state.clienti = _.uniq(action.payload);
    },
    aggiornaOpzioniTabella(state, action) {
      state.opzioniTabella = action.payload;
    },
    aggiornaContrattoAttuale(state, action) {
      state.currentContratto = action.payload;
    },
    mostraOrdiniFatture(state, action) {
      state.tipoModale = action.payload;
      state.mostraOrdiniFatture = true;
    },
    nascondiOrdiniFatture(state) {
      state.mostraOrdiniFatture = false;
    },
    aggiornaOrdini(state, action) {
      state.ordini = action.payload;
    },
    aggiornaFatture(state, action) {
      state.fatture = action.payload;
    },
    caricamentoModale(state, action) {
      state.caricamentoModale = Boolean(action.payload);
    },
    aggiornaClienteCorrente(state, action) {
      state.currentCliente = action.payload;
    },
  },
});

export const {
  caricamento,
  aggiornaContratti,
  aggiornaOpzioniTabella,
  aggiornaContrattoAttuale,
  mostraOrdiniFatture,
  aggiornaOrdini,
  aggiornaFatture,
  caricamentoModale,
  nascondiOrdiniFatture,
  aggiornaClienti,
  aggiornaClienteCorrente,
} = contrattiSlice.actions;
const contrattiReducer = contrattiSlice.reducer;

export default contrattiReducer;
